import { BaseRouteService } from 'core/services';

class UnitOfMeasureRouteService extends BaseRouteService {
    constructor() {
        super('units-of-measure');
    }

    find(filter) {
        return super.find(this.base + '/{?searchQuery,isActive,page,rpp,sort,embed,fields}', filter);
    }
}

export default UnitOfMeasureRouteService;
